<template>
<div class="container">
  <div class="row">
    <div class="col">
      <b-alert variant="success" dismissible :show="showResponse" @dismissed="showResponse=false">
        <p>予約を登録しました</p>
      </b-alert>
      <b-alert variant="danger" dismissible :show="showError" @dismissed="showError=false">
        <p>予約に失敗しました<template v-if="lastError">: {{ lastError }}</template></p>
      </b-alert>
      <b-form @submit.prevent="onSubmit" @reset="onReset">
        <b-form-group label="望遠鏡">
          <b-form-select v-model="form.telescopeId" :options="telescopeList" required @change="$emit('telescopeChanged', $event)"></b-form-select>
        </b-form-group>

        <b-form-group label="撮影天体">
          <b-form-select v-model="form.target" :options="targetList" required></b-form-select>
        </b-form-group>

        <b-form-group label="撮影日時">
          <div class="form-row">
            <b-input-group class="col-sm-4">
              <b-form-select v-model="form.start.date" :options="dateList" required></b-form-select>
            </b-input-group>
          </div>
        </b-form-group>

        <b-button type="submit" variant="primary" :disabled="disableSubmit">予約</b-button>
        <b-button type="reset" variant="danger" :disabled="disableSubmit">リセット</b-button>
      </b-form>
    </div>
  </div>
</div>
</template>
<script>
import moment from 'moment'
import axios from 'axios'

function parseDisplayDateToUTCDate(year, month, day, hour, minute, second, timezone) {
  timezone = timezone || 0;
  const d = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
  return new Date(d.getTime() - timezone * 1000);
}

export default {
  name: 'easy-form',
  props: ['telescopeId', 'telescopeList', 'targetList', 'dateList'],
  data() {
    let day = moment()
    if ( day.hours() >= 12 ) {
        day = day.add(1, "days");
    }
    return {
      lastError: "",
      showResponse: false,
      showError: false,
      disableSubmit: false,

      form: {
        telescope: "南阿蘇ルナ天文台 82cm",
        // telescope_id: "63ce0ad6-8eb4-4007-9c57-4e1c6eb2d8cd",
        telescopeId: this.telescopeId,
        target: "M45",
        start: {
          date: day.format('YYYY-MM-DD')
        },
      },
    }
  },
  methods: {
    onSubmit() {
      // dismiss alerts
      this.resetResponse();

      let date = this.form.start.date.split("-");
      let booking = {
        year: date[0],
        month: date[1],
        day: date[2],
        target: this.form.target
      }

      this.beginSubmit();
      this.$store.state.loginUser.session.user.getIdToken(true).then((idToken) => {
        axios.post(this.$store.state.config.API_ROOT + "/schedule/add/" + this.form.telescopeId + "/auto", booking, {
          headers: {
            "Authorization": "Bearer " + idToken
          }
        }).then((response) => {
          this.$emit('addedBooking', response.data)
          this.onSuccess();
        }).catch((error) => {
          let code = error.response.status;
          if (code == 403) {
            this.onError("認証に失敗しました");
          } else if (code == 405) {
            this.onError("送信に失敗しました");
          } else if (code == 404) {
            this.onError("不明な望遠鏡です");
          } else if (code == 400) {
            if (error.response.data.startsWith("not enough parameter") ||
                error.response.data.startsWith("wrong parameter")) {
              this.onError("パラメータエラー");
            } else {
              this.onError("パラメータエラー （不明なエラー）");
            }
          } else if (code == 412) {
            if (error.response.data.startsWith("expiration check failed")) {
              this.onError("登録期限を超えています");
            } else if (error.response.data.startsWith("out of service")) {
              this.onError("サービス提供期間外です");
            } else if (error.response.data.startsWith("service in suspend")) {
              this.onError("サービス停止期間です");
            } else if (error.response.data.startsWith("too long order per a day")) {
              this.onError("1日あたりの撮影時間を超過しています");
            } else if (error.response.data.startsWith("too much order per a day")) {
              this.onError("1日あたりの撮影枚数を超過しています");
            } else if (error.response.data.startsWith("too short exposure")) {
              this.onError("露出時間が短すぎます");
            } else if (error.response.data.startsWith("too long exposure")) {
              this.onError("露出時間が長すぎます");
            } else if (error.response.data.startsWith("too short total exposure")) {
              this.onError("トータル露出時間が短すぎます");
            } else if (error.response.data.startsWith("too long total exposure")) {
              this.onError("トータル露出時間が長すぎます");
            } else if (error.response.data.startsWith("too little order")) {
              this.onError("撮影枚数が少なすぎます");
            } else if (error.response.data.startsWith("too much order")) {
              this.onError("撮影枚数が多すぎます");
            } else if (error.response.data.startsWith("Conflicting request")) {
              this.onError("予約が重複しています");
            } else if (error.response.data.startsWith("no such object")) {
              this.onError("未登録の天体です");
            } else if (error.response.data.startsWith("bad angle")) {
              this.onError("撮影基準高度に達していません");
            } else if (error.response.data.startsWith("not supported")) {
              this.onError("この望遠鏡は自動予約に対応していません");
            } else if (error.response.data.startsWith("schedule is full")) {
              this.onError("良好な時間帯が埋まっているため予約できませんでした");
            } else {
              this.onError("前提条件で失敗しました （不明なエラー）");
            }
          } else {
            this.onError("不明なエラー");
          }
        });
      }).catch((error) => {
        this.onError("セッションが無効です");
      });
      return false;
    },
    onReset() {
      let day = moment();
      if (day.hours() >= 12) {
          day = day.add(1, "days");
      }
      this.form = {
        telescope: "南阿蘇ルナ天文台 82cm",
        telescopeId: "63ce0ad6-8eb4-4007-9c57-4e1c6eb2d8cd",
        target: "M45",
        start: {
          date: day.format("YYYY-MM-DD")
        }
      }
    },
    beginSubmit() {
      this.disableSubmit = true;
      this.$forceUpdate();
    },
    endSubmit() {
      this.disableSubmit = false;
    },
    resetResponse() {
      this.lastError = "";
      this.showResponse = false;
      this.showError = false;
    },
    onSuccess() {
      this.endSubmit();
      this.showResponse = true;
      this.$forceUpdate();
    },
    onError(error) {
      this.endSubmit();
      this.lastError = error;
      this.showError = true;
      this.$forceUpdate();
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EasyForm.vue